import { AuthorProfile } from '@src/components/sco/AuthorProfile';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { pageWithNavbar } from '@src/templates/PageWithNavBar';
import { useParams } from 'next/navigation';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default pageWithNavbar(function Page() {
  const activeContent = useActiveContentContext();
  const routeParams = useParams() as Record<string, string | undefined> | null;
  const authorSlug = `${routeParams?.authorSlug}`;
  useUniversalEffect(() => {
    activeContent.setItem(null);
    activeContent.setBreadcrumbs([{
      title: 'Authors',
      href: '/authors'
    }]);
  }, []);
  return <AuthorProfile slug={authorSlug} />;
});